"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MINIGAMES_PIGGY_BANK_LIFETIME_THRESHOLD = exports.MINIGAMES_PIGGY_BANK_REWARD = exports.SUB_SOURCE_ID_PLAYBITE = exports.SUB_SOURCE_ID_PBR = void 0;
exports.SUB_SOURCE_ID_PBR = 'zbqc2';
exports.SUB_SOURCE_ID_PLAYBITE = 'nxrul';
exports.MINIGAMES_PIGGY_BANK_REWARD = 1;
exports.MINIGAMES_PIGGY_BANK_LIFETIME_THRESHOLD = 1000;
